import React, { type FC } from 'react';

import { TextButton } from '@fragment/ui/src/components/Button/TextButton/TextButton';
import { Icon } from '@fragment/ui/src/components/Icon';

export const linkTypeToDocsUrl = {
  IncreaseLink: 'https://fragment.dev/guides/sync-payments#increase-link',
  UnitLink: 'https://fragment.dev/guides/sync-payments#unit-link',
  CustomLink: 'https://fragment.dev/guides/sync-payments#custom-link',
  StripeLink: 'https://fragment.dev/guides/sync-payments#stripe-link',
  Reconciliation: 'https://fragment.dev/guides/reconcile-payments',
  LinkedLedgerAccount:
    'https://fragment.dev/guides/reconcile-payments#linked-ledger-accounts',
  Consistency: 'https://fragment.dev/guides/configure-consistency',
} as const;

export type DocsLinkProps = {
  linkType: keyof typeof linkTypeToDocsUrl;
  displayText?: string;
};
export const DocsLink: FC<DocsLinkProps> = ({
  linkType,
  displayText = 'Docs',
}) => (
  <a
    href={linkTypeToDocsUrl[linkType]}
    target="_blank"
    tabIndex={-1}
    rel="noreferrer"
  >
    <TextButton>
      {displayText} <Icon type="external" size="md" />
    </TextButton>
  </a>
);
